function isOwnGroup(comm) {
  return comm?.permissions?.member || comm?.permissions?.author;
}

export default isOwnGroup;
